export function FomatText(text) {
  if (!text) return "";
  
  // Replace multiple spaces with a single space
  text = text.replace(/\s+/g, " ");
  
  // Remove leading and trailing spaces
  text = text.trim();
  
  // Convert to lowercase
  text = text.toLowerCase();
  
  // Capitalize the first letter of each word
  text = text.replace(/\b\w/g, (char) => char.toUpperCase());
  
  return text;
}